import React, { useEffect, useState } from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Chip from '@mui/material/Chip';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

function getStyles(name: string, personName: readonly string[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium
  };
}

interface MultiSelectProps {
  label: string;
  options: {
    id: string;
    name: string;
  }[];
  onChange?: (values: string[]) => void;
}

const MultiSelect: React.FC<MultiSelectProps> = ({ label, options, onChange }) => {
  const theme = useTheme();
  const [personName, setPersonName] = useState<string[]>([]);

  const handleChange = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value }
    } = event;
    const data = typeof value === 'string' ? value.split(',') : value;
    if (data[data.length - 1] === 'all') {
      setPersonName([]);
      return;
    }
    setPersonName(data);
  };
  useEffect(() => {
    if (onChange) {
      onChange(personName);
    }
  }, [personName]);

  return (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={personName}
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" label={label} />}
        sx={{
          '.MuiSelect-select': {
            padding: '12px',
            minHeight: '2rem!important'
          }
        }}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={options.find((data) => data.id.toString() == value)?.name} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        <MenuItem
          value={'all'}
          onClick={() => setPersonName([])}
          style={{
            fontWeight:
              personName.length == 0
                ? theme.typography.fontWeightMedium
                : theme.typography.fontWeightRegular
          }}
        >
          {'ทั้งหมด'}
        </MenuItem>
        {options.map(({ id, name }) => (
          <MenuItem key={id} value={id} style={getStyles(name, personName, theme)}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelect;
